import ComponentSpinner from "../@core/components/spinner/Loading-spinner"

const PageRefresh = () => {
  return (
    <div className="pageRefresh">
      <ComponentSpinner />
    </div>
  )
}
export default PageRefresh